"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var useStyles = makeStyles_1.default(function () { return ({
    topRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 2,
    },
    dot: {
        width: 11,
        height: 11,
        borderRadius: 11,
        marginRight: 5,
        backgroundColor: function (props) { return props.dotColor; },
    },
    label: {
        fontSize: 12,
    },
}); });
function DeviceLegend(_a) {
    var className = _a.className, dotColor = _a.dotColor, label = _a.label, percent = _a.percent;
    var classes = useStyles({ dotColor: dotColor });
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: classes.topRow },
            react_1.default.createElement("div", { className: classes.dot }),
            react_1.default.createElement(Typography_1.default, { color: "primary", className: classes.label }, label)),
        react_1.default.createElement(Typography_1.default, { color: "primary", variant: "h5" },
            percent,
            "%")));
}
exports.default = DeviceLegend;
